class LoggedOutHeader {
    constructor() {
        this.init();
    }

    init() {
        if(!document.getElementById('logged-out-header')) {
            console.error('LoggedOutHeader: Header element not found.');
            return;
        }

        this.dropdownButtons = document.querySelectorAll('.logged-out-nav-section-btn');
        // Initialize event listeners for dropdowns and menu buttons
        this.setupDropdowns();
        this.setupMenuButtons();
        this.setupResizeListener();
        this.setupMobileInteractions();
    }

    setupDropdowns() {
        this.dropdownButtons.forEach(button => {
            button.addEventListener('click', (event) => {
                if(window.innerWidth < 992) {
                    this.toggleDropdown(button);
                }
            });
        });
    }

    toggleDropdown(button) {
        const isExpanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', !isExpanded);
        const submenu = button.nextElementSibling;
    
        if (submenu && submenu.classList.contains('logged-out-submenu')) {
            if (!isExpanded) {
                submenu.style.height = submenu.scrollHeight + 'px'; // Expand to full height
            } else {
                submenu.style.height = ''; // Collapse to zero height
            }
        }
    }

    setupMenuButtons() {
        const menuOpenButton = document.querySelector('.nav-main-menu-btn');
        const menuCloseButton = document.querySelector('.nav-main-menu-close-tablet');

        if (menuOpenButton) {
            menuOpenButton.addEventListener('click', () => {
                this.toggleMenu(true);
            });
        }

        if (menuCloseButton) {
            menuCloseButton.addEventListener('click', () => {
                this.toggleMenu(false);
            });
        }
    }

    setupResizeListener() {
        window.addEventListener('resize', () => {
            const viewportWidth = window.innerWidth;

            // Close all dropdowns if switching to desktop breakpoint
            if (viewportWidth >= 992) { // Adjust breakpoint as needed
                this.dropdownButtons.forEach(button => {
                    button.setAttribute('aria-expanded', 'false');
                    const submenu = button.nextElementSibling;
                    if (submenu && submenu.classList.contains('logged-out-submenu')) {
                        submenu.style.height = '';
                    }
                });
                this.toggleMenu(false); // Close the menu if it was open
            }
        });
    }

    setupMobileInteractions(){
        document.getElementById('logged-out-header-mobile-overlay').addEventListener('click', () => this.toggleMenu(false));
    }

    toggleMenu(isOpen) {
        if(isOpen){
            document.body.classList.add('expanded');
        }else{
            document.body.classList.remove('expanded');
        }
    }
    
}

module.exports = LoggedOutHeader;